import { Helpers } from '../../helpers';
import { IProjectSuperType } from '../../interfaces/iproject-super-type';
import { ProjectType } from '../project-type';

export class ProjectSuperTypeBase {
  ProjectSuperTypeId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectTypes_ProjectSuperType?: Array<ProjectType> | null;

  constructor(item?: IProjectSuperType) {
    if (item) {

      this.ProjectSuperTypeId = item.ProjectSuperTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectTypes_ProjectSuperType = Helpers.createClassArray(ProjectType, item.ProjectTypes_ProjectSuperType);
    }
  }
}